import React, { Component } from "react";
import Sidebar from "./components/common/sidebar_components/sidebar";
import Footer from "./components/common/footer";
import Header from "./components/common/header_components/header";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import Sidebar_Agent from "./components/common/sidebar_components/Sidebar_Agent";
import { change_Lang } from "./actions/Helper_action";
import Header_Agent from "./components/common/header_components/Header_Agent";

export class All extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ltr: true,
      divName: "RTL",
    };
  }
  ChangeRtl(divName) {
    if (divName === "RTL") {
      document.body.classList.add("rtl");
      this.setState({ divName: "LTR" });
    } else {
      document.body.classList.remove("rtl");
      this.setState({ divName: "RTL" });
    }
  }
  render() {
    const { user, isAuth } = this.props;
    return (
      <>
        {isAuth && (
          <div>
            <div className="page-wrapper">
              {user.role !== "agent" && user.role !== "accountant" ? (
                <Header />
              ) : (
                <Header_Agent />
              )}
              <div className="page-body-wrapper">
                {user.role !== "agent" && user.role !== "accountant" ? (
                  <Sidebar />
                ) : (
                  <Sidebar_Agent />
                )}
                <div className="page-body">{this.props.children}</div>
                {isMobile !== true ? <Footer /> : null}
              </div>
            </div>
            {/* <div
        className="btn-light custom-theme"
        onClick={() => this.ChangeRtl(this.state.divName)}
      >
        {this.state.divName}
      </div> */}
          </div>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.AuthReducer.user,
    isAuth: state.AuthReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(All);
